export default "__VITE_ASSET__D2kB6VTB__"